import React, { useState } from "react";
import { useInterval } from "react-use";
import { useTranslation } from "react-i18next";
// import { useHover } from "react-use";
import classnames from "classnames";

import "./styles.less";

export const BuildIdaasBuyWay = () => {
  const [element, setElement] = useState(1);
  const { t } = useTranslation();
  const list = [
    {
      title: "71%",
      subTitle: `${t("solution.buildIdaas.buy.item1.title")}`,
    },
    {
      title: "548%",
      subTitle: `${t("solution.buildIdaas.buy.item2.title")}`,
    },
    {
      title: ``,
      subTitle: `${t("solution.buildIdaas.buy.item3.title")}`,
    },
  ];

  useInterval(() => {
    if (element < 2) {
      setElement(element + 1);
    } else {
      setElement(0);
    }
  }, 8000);

  return (
    <div className="build-idaas-buy-way">
      <div className="inner">
        <div key="1" className="top">
          <div className="headline">{t("solution.buildIdaas.buy.title")}</div>
        </div>
        <div key="2" className="content-warp">
          <div className="content-left">
            {list.map((item, index) => {
              const cls = classnames({
                item: true,
                selected: element === index,
              });
              return (
                <div className={cls}>
                  <div>
                    {index === 2 ? (
                      <span className="data">
                        <i className="icon authing-icon authing-rocket icon-style"></i>
                      </span>
                    ) : (
                      <div className="data">{item.title}</div>
                    )}
                    <div className="text">{item.subTitle}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="content-right">
            <div className="item-descript">{t("solution.buildIdaas.buy.item1.descript")}</div>
            <div className="item-descript">{t("solution.buildIdaas.buy.item2.descript")}</div>
            <div className="item-descript">{t("solution.buildIdaas.buy.item3.descript")}</div>

            {/* <div>
              <div className="title">
                {list[element].title} {list[element].subTitle}
              </div>
              <div className="text">{list[element].content}</div>
            </div>

            <div
              className="button-warp"
              onClick={() => {
                navigate("/advantage");
              }}
            >
              <Button style={{ margin: 0 }}>{t("common.button.see-more")}</Button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
